import { apiClient } from "lib/apiClient";

export const getMarketAreasAvailable = async (): Promise<boolean> => {
  const response = await apiClient.get<boolean>("/market-areas/available");

  return response.data;
};
